import React from 'react';

const NavigationLogo = ({ logoUrl, appName }) => {
  return (
    <div className='d-flex align-items-center justify-content-between'>
      <a href='http://carenuity.com' className='logo d-flex align-items-center'>
        <img src={logoUrl} alt='' />
        <span className='d-none d-lg-block'>{appName}</span>
      </a>
      <i
        className='bi bi-list toggle-sidebar-btn'
        onClick={() => {
          document.querySelector('body').classList.toggle('toggle-sidebar');
        }}
      ></i>
    </div>
  );
};

export default NavigationLogo